

/**
 * a function that toggles the visibility of the payment gateway details based
 * on the selected gateway.
 * We build this on-top of the Bootstrap collapse functionality, but trigger it
 * manually to suit our needs.
 */
(function(jQuery) {
  jQuery(function() {
    var checkout = jQuery('form.woocommerce-checkout');
    var toggleSelector = '[data-cs-payment-method]';
    var detailSelector = '[data-cs-payment-method-details]';

    if (checkout.length) {
      checkout.on('change', toggleSelector, function(event) {
        var toggle = jQuery(event.target);
        var id = toggle.data('cs-payment-method');

        var details = checkout.find(detailSelector);
        if (details.length) {
          details.collapse('hide');

          for (var i = 0; i < details.length; i++) {
            var detail = jQuery(details[i]);

            var detailId = detail.data('cs-payment-method-details');

            if (detailId == id) {
              detail.collapse('show');
            }
          }
        }
      });
    }
  });
})(jQuery);

